import Backbone from 'backbone'
import appDisplay from 'scoreboard/components/app-display'
import bootslideOption from 'scoreboard/components/bootslide/option.hbs'
import ScorecardItemImportWizard from 'scoreboard/scorecards/edit/import/scorecard-item-import-wizard'
import $ from 'jquery'
import ViWizard from 'scoreboard/imports/vi/vi-wizard'
import guard from 'scoreboard/components/unsaved/guard'
import permissions from 'scoreboard/components/permissions'
import config from 'scoreboard/components/config'
import InitiativeItemImportWizard from 'scoreboard/initiatives/import/initiative-item-import-wizard'

var ImportOption = Backbone.View.extend({

	events: {
		'click': 'openImport'
	},

	render: function () {
		this.$el.html(bootslideOption({ icon: this.icon, label: this.label }))
		return this
	}

})

var options = {

	scorecardItems: function(options={}) {
		return ImportOption.extend({
			icon: 'scorecard',
			label: 'scorecards.scorecardNodes',
			menuLabel: 'scorecards.scorecardNodes',
			mobileLabel: 'scorecards.importScorecardNodes',
			openImport: function() {
				// #31304 When the import is complete, the view is refreshed to
				// the Overview tab. If they are editing a form, give them the
				// opportunity to save before starting the import
				guard.conditionallyRun(() => {
					/**
					 * Opens the scorecard item import wizard
					 */
					appDisplay.dialog($.get('api/imports/import-data', { statuses: true }), data => {
						let wizard = new ScorecardItemImportWizard()
						wizard.initialize({
							organizationId: options.get('organizationId'),
							itemId: options.get('id'),
							rootId: options.get('rootId'),
							connections: data.connections,
							type: 'scorecard-item'
						})
						return wizard._view()
					})
				})
			}
		})
	},

	kpiValues: function(metric) {
		return ImportOption.extend({
			icon: 'metric',
			label: 'home.metricUpdates.import',
			menuLabel: 'home.metricUpdates.import',
			mobileLabel: 'home.metricUpdates.importTooltip',
			openImport: function() {
				let viWizard = ViWizard.start({
					type: 'metric-value',
					doneKey: 'admin.import.run'
				})
				viWizard.on('import-complete', () => {
					metric.trigger('import-complete')
				})
			}
		})
	},

	/**
	 * Returns a list of valid ImportOption menu items for the current user and the
	 * given scorecard item
	 */
	forScorecardItem: function (scorecardItem) {
		let options = []
		// #49873 hide the import button when creating a new scorecard item
		if (scorecardItem.isNew()) {
			return options
		}
		//#33233 prevent imports on unclassified nodes on the high
		let replicationModify = permissions.isEditableIfReplicated(scorecardItem)
			|| scorecardItem.transformedDocking()
		let notDockingNode = scorecardItem.get('type') != 'docking'
		if (permissions.anyStructure() && replicationModify && notDockingNode) {
			options.push(this.scorecardItems(scorecardItem))
		}

		// #32171 If the user has permissions to import values for at least one
		// metric, show the import option. The import dialog doesn't care about
		// what the current scorecard item is, so show the menu option regardless
		// of whether the user can import for the current scorecard item.
		if (permissions.importMetricValues() && replicationModify && notDockingNode) {
			options.push(this.kpiValues(scorecardItem))
		}

		return options
	},

	/**
	 * Returns a list of valid ImportOption menu items for the current user and
	 * the given initiative item
	 */
	forInitiativeItem: function(initiativeItem) {
		let options = []
		let organizationId = initiativeItem.get('organizationId')

		// permission to create initiatives
		if (permissions.modifyInitiatives(organizationId)) {
			options.push(this.initiativeItems(initiativeItem))
		}

		// permissions to update initiative status
		if (permissions.updateInitiativeStatus(organizationId)) {
			options.push(this.initiativeStatus(initiativeItem))
		}

		return options
	},

	initiativeStatus: function (initiative) {
		return ImportOption.extend({
			icon: 'task',
			label: 'initiatives.overview.initiativeStatus',
			menuLabel: 'initiatives.overview.initiativeStatus',
			mobileLabel: 'initiatives.overview.import',
			openImport: function() {
				let viWizard = ViWizard.start({
					type: 'initiative-status',
					doneKey: 'admin.import.run'
				})
				viWizard.on('import-complete', () => {
					initiative.trigger('import-complete')
				})
			}
		})
	},

	initiativeItems: function (options={}) {
		return ImportOption.extend({
			icon: 'initiative',
			label: 'initiatives.initiativeItems',
			menuLabel: 'initiatives.initiativeItems',
			mobileLabel: 'initiatives.importInitiativeItems',
			openImport: () => this.displayInitiativeItemImportWizard(options)
		})
	},

	/**
	 * Opens the initiative item import wizard
	 */
	displayInitiativeItemImportWizard: function(options={}) {
		return guard.conditionallyRun(() => {
			/**
			 * Opens the initiative item import wizard
			 */
			appDisplay.dialog($.get('api/imports/import-data',
				{statuses: true}), data => {
				let wizard = new InitiativeItemImportWizard()
				wizard.initialize({
					organizationId: options.get('organizationId'),
					itemId: options.get('id'),
					itemLabel: options.get('label'),
					connections: data.connections
				})
				return wizard._view()
			})
		})
	}
}

export default options
options.__filename__ = 'components/import-options.js'
